/**
 * Base state for current module
 */
const state = {
  feed: [],
  largestQuerySize: 0,
  props: {
    limit: 30,
    contentTypes: ["news", "events", "content"],
  },
  defaultProps: [
    {
      key: "limit",
      label: "Limit",
      helperText: "Select the number of items to view (max 30)",
      type: "text",
      value: 30,
      validation: "required:true|between:1,30",
    },
    {
      key: "contentTypes",
      label: "Content types",
      helperText: "Select which types of content you want to display",
      type: "checkbox",
      value: ['news','events','content'],
      options: [
        {
          name: "Interest group news",
          value: "news",
        },
        {
          name: "Interest group events",
          value: "events",
        },
        {
          name: "Interest group pages",
          value: "content",
        },
      ],
    },
  ],
  // defaultProps: {
  //   limit: 10,
  //   contentTypes: ["news", "events", "content"],
  // },
  propOptions: {
    contentTypes: {
      multiple: true,
      options: [
        {
          name: "News",
          value: "news",
        },
        {
          name: "Events",
          value: "events",
        },
        {
          name: "Content",
          value: "content",
        },
      ],
    },
  },
  status: "WAITING",
};

export default state;
